export const SHARE_CODE = 'share_code'
export const PASSWORD = 'password'
export const APP_MUTATIONS = {
  TOGGLE_SIDE_BAR_COLLAPSED: 'TOGGLE_SIDE_BAR_COLLAPSED',
  TOGGLE_DEVICE: 'TOGGLE_DEVICE'
}
